document.addEventListener('DOMContentLoaded', function () {
  var target = document.querySelector('.js-sitemap-products');
  var loading = document.querySelector('.js-sitemap-loading');
  var pagination = document.querySelector('.js-sitemap-products-pagination');

  if (!target || !pagination) return;

  var products = [];
  var seenUrls = {};

  var currentPage = parseInt(pagination.getAttribute('data-current-page'), 10) || 1;
  var totalPages = parseInt(pagination.getAttribute('data-pages'), 10) || 1;

  function getPageUrl(page) {
    var url = new URL(window.location.href);

    url.searchParams.set('page', page);

    return url.toString();
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getProductGroupLetter(title) {
    var firstChar = String(title || '').trim().charAt(0).toUpperCase();

    if (/^[A-Z]$/.test(firstChar)) {
      return firstChar;
    }

    return '#';
  }

  function collectProductsFromElement(element) {
    var links = element.querySelectorAll('a[data-title]');

    links.forEach(function (link) {
      var productUrl = link.getAttribute('href');
      var productTitle = link.getAttribute('data-title') || link.textContent.trim();

      if (!productUrl || seenUrls[productUrl]) return;

      seenUrls[productUrl] = true;

      products.push({
        title: productTitle,
        url: productUrl
      });
    });
  }

  function renderProducts() {
    products.sort(function (a, b) {
      var letterA = getProductGroupLetter(a.title);
      var letterB = getProductGroupLetter(b.title);

      if (letterA === '#' && letterB !== '#') return -1;
      if (letterA !== '#' && letterB === '#') return 1;

      if (letterA === '#' && letterB === '#') {
        var firstA = String(a.title || '').trim().charAt(0);
        var firstB = String(b.title || '').trim().charAt(0);
        var isDigitA = /[0-9]/.test(firstA);
        var isDigitB = /[0-9]/.test(firstB);
        if (isDigitA && !isDigitB) return -1;
        if (!isDigitA && isDigitB) return 1;
      }

      return a.title.localeCompare(b.title, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    });

    var html = '';
    var currentLetter = '';

    products.forEach(function (product) {
      var letter = getProductGroupLetter(product.title);

      if (letter !== currentLetter) {
        currentLetter = letter;
        html += '<h3 data-letter="' + escapeHtml(letter) + '">' + escapeHtml(letter) + '</h3>';
      }

      html += '<a href="' + escapeHtml(product.url) + '" data-title="' + escapeHtml(product.title) + '" class="link link--hover link--text link--wave">';
      html += '<span>' + escapeHtml(product.title) + '</span>';
      html += '</a>';
    });

    target.innerHTML = html;

  }

  function fetchProductPage(page) {

    return fetch(getPageUrl(page))
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch product page ' + page);
        }

        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var pageProducts = doc.querySelector('.js-sitemap-products');

        if (!pageProducts) {
          return;
        }

        collectProductsFromElement(pageProducts);

      });
  }

  function loadMoreProductPages() {
    collectProductsFromElement(target);

    
    var chain = Promise.resolve();

    for (var page = 2; page <= totalPages; page++) {
      chain = chain.then(
        (function (pageNumber) {
          return function () {
            return fetchProductPage(pageNumber);
          };
        })(page)
      );
    }

    chain
      .then(function () {
        renderProducts();

        if (loading) {
          loading.remove();
        }

      })
      .catch(function (error) {
        console.error(error);

        renderProducts();

        if (loading) {
          loading.textContent = 'Some products could not be loaded.';
        }
      });
  }

  loadMoreProductPages();
});